class Crossfader {
    constructor(element) {
        this.el = element;

        this.init();
    }

    init() {
        this.startCrossfader();
    }

    startCrossfader() {
        const slides = this.el.querySelectorAll("[data-crossfader-item]");
        const delay = this.el.dataset.delay
            ? parseInt(this.el.dataset.delay)
            : 0;

        let active_slide = slides[0];
        active_slide.classList.add("active");

        if (slides.length < 2) return;

        let prev_slide = slides[slides.length - 1];
        prev_slide.classList.add("prev-active");

        setTimeout(() => {
            // Store the interval on the element so it can be paused using the reference in PlayPause.js
            this.el.crossfader_interval = setInterval(() => {
                const active_index = [...slides].indexOf(active_slide);
                const next_index = slides[active_index + 1]
                    ? active_index + 1
                    : 0;
                let next_slide = slides[next_index];

                prev_slide.classList.remove("prev-active");
                active_slide.classList.remove("active");
                active_slide.classList.add("prev-active");
                next_slide.classList.add("active");

                prev_slide = active_slide;
                active_slide = next_slide;
            }, 3000);
        }, delay);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const elements = document.querySelectorAll("[data-crossfader]");

    elements.forEach((element) => {
        new Crossfader(element);
    });
});

export default Crossfader;
